// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"49fbef37","570":"a644e930"}[chunkId] + ".chunk.css";
};